import React from 'react';
import { Grid2 as Grid, Typography } from '@mui/material';

interface InfoRowProps {
  label: string;
  children: React.ReactNode;
  isLast?: boolean;
}

const InfoRow: React.FC<InfoRowProps> = ({ label, children, isLast = false }) => {
  const borderStyle = isLast ? {} : { borderBottom: '1px solid', borderColor: 'border.default' };

  return (
    <>
      <Grid size={6} sx={{ ...borderStyle, p: 1 }}>
        <Typography color="textSecondary">{label}</Typography>
      </Grid>
      <Grid size={6} sx={{ ...borderStyle, p: 1 }}>
        {children}
      </Grid>
    </>
  );
};

export default InfoRow;
